// Gestion du panier WooCommerce
const cartHandler = {
    init: function() {
        this.bindEvents();
    },
    
    bindEvents: function() {
        // Écouter les événements WooCommerce
        document.body.addEventListener('wc_fragments_loaded', this.updateCartIcon);
        document.body.addEventListener('wc_fragments_refreshed', this.updateCartIcon);
        document.body.addEventListener('added_to_cart', this.updateCartIcon);
        document.body.addEventListener('removed_from_cart', this.updateCartIcon);
    },
    
    updateCartIcon: function() {
        // Animation lors de la mise à jour
        const cartIcon = document.querySelector('.cart-icon');
        if (cartIcon) {
            cartIcon.classList.add('animate-bounce');
            setTimeout(() => {
                cartIcon.classList.remove('animate-bounce');
            }, 600);
        }
    }
};

// Mise à jour automatique du panier lors du changement de quantité
async function updateCartQuantities(form) {
    const cartTable = form.querySelector('table.woocommerce-cart-form__contents');
    const cartCollaterals = document.querySelector('.cart-collaterals');

    if (cartTable) cartTable.style.opacity = '0.5';
    if (cartCollaterals) cartCollaterals.style.opacity = '0.5';

    const formData = new FormData(form);
    formData.append('update_cart', 'Update cart');

    try {
        const response = await fetch(form.action, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Remplacer le tableau du panier
        const newTable = doc.querySelector('table.woocommerce-cart-form__contents');
        if (newTable && cartTable) {
            cartTable.replaceWith(newTable);
        }

        // Remplacer le récapitulatif (totaux)
        const currentCollaterals = document.querySelector('.cart-collaterals');
        const newCollaterals = doc.querySelector('.cart-collaterals');
        if (newCollaterals && currentCollaterals) {
            currentCollaterals.replaceWith(newCollaterals);
        }

        // Déclencher le rafraîchissement des fragments WooCommerce (mini-panier header…)
        if (window.jQuery) {
            window.jQuery(document.body).trigger('wc_fragment_refresh');
        }

    } catch {
        if (cartTable) cartTable.style.opacity = '1';
        if (cartCollaterals) cartCollaterals.style.opacity = '1';
    }
}

function initCartAutoUpdate() {
    const cartForm = document.querySelector('form.woocommerce-cart-form');
    if (!cartForm) return;

    let debounceTimer;

    cartForm.addEventListener('change', (e) => {
        if (!e.target.matches('input.qty')) return;

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            updateCartQuantities(cartForm);
        }, 700);
    });
}

// Auto-initialisation
document.addEventListener('DOMContentLoaded', () => {
    if (typeof wc_add_to_cart_params !== 'undefined') {
        cartHandler.init();
    }
    initCartAutoUpdate();
});

export { cartHandler };